export const strengthStrings = {
  Poor: _TL_('Poor'),
  Average: _TL_('Average'),
  Good: _TL_('Good'),
  Excellent: _TL_('Excellent'),
};

export const actionItemStrings = {
  AddMoreHeadlines: _TL_('Add more headlines'),
  AddMoreDescriptions: _TL_('Add more descriptions'),
  MoreCombinations: _TL_('Add more combinations'),
  LongerHeadlines: _TL_('Add longer headlines'),
  LongerDescriptions: _TL_('Add longer descriptions'),
  DistinctHeadlines: _TL_('Make your headlines more unique'),
  DistinctDescriptions: _TL_('Make your descriptions more unique'),
  UnpinHeadlinePositions: _TL_('Unpin headline positions'),
  UnpinDescriptionPositions: _TL_('Unpin description positions'),
};

export const adStrengthSuggestionTipsStrings = {
  Ad_Strength_Suggestion_Tips_Category_Product_Title: _TL_('Products or service'),
  Ad_Strength_Suggestion_Tips_Category_Product_Subtitle: _TL_('What does your business offer?'),
  Ad_Strength_Suggestion_Tips_Category_Product_Item1: _TL_('Reliable AC Systems'),
  Ad_Strength_Suggestion_Tips_Category_Product_Item2: _TL_('Top-Rated Moving Service'),
  Ad_Strength_Suggestion_Tips_Category_Product_Item3: _TL_('Secure Self Storage'),
  Ad_Strength_Suggestion_Tips_Category_Product_Item4: _TL_('Workout Clothes &amp; Activewear'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Title: _TL_('Benefits'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Subtitle: _TL_('How do your products or services help people?'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Item1: _TL_('No Cooking Required'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Item2: _TL_('Three Convenient Locations'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Item3: _TL_('In-Home Tutoring'),
  Ad_Strength_Suggestion_Tips_Category_Benefits_Item4: _TL_('Quick Delivery'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Title: _TL_('Brand'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Subtitle: _TL_('What phrases use your brand?'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Item1: _TL_('[Brand Name]'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Item2: _TL_('[Brand.com]'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Item3: _TL_('Best Prices from [Brand]'),
  Ad_Strength_Suggestion_Tips_Category_Brand_Item4: _TL_('Official [Brand] site'),
  Ad_Strength_Suggestion_Tips_Category_Action_Title: _TL_('Call to action'),
  Ad_Strength_Suggestion_Tips_Category_Action_Subtitle: _TL_('What do you want your customers to do?'),
  Ad_Strength_Suggestion_Tips_Category_Action_Item1: _TL_('Book Your Next Adventure'),
  Ad_Strength_Suggestion_Tips_Category_Action_Item2: _TL_('Schedule a Test Drive'),
  Ad_Strength_Suggestion_Tips_Category_Action_Item3: _TL_('Call for an Appointment'),
  Ad_Strength_Suggestion_Tips_Category_Action_Item4: _TL_('Get a Free Personalized Quote'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Title: _TL_('Inventory and selection'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Subtitle: _TL_('What categories, options, and selections do you offer?'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Item1: _TL_('The Latest Summer Styles'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Item2: _TL_('Puppy Toys'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Item3: _TL_('50 Styles in 50 Colors'),
  Ad_Strength_Suggestion_Tips_Category_Inventory_Item4: _TL_('Thousands of Instruments to Choose From'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Title: _TL_('Pricing and fees'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Subtitle: _TL_('What are your prices, taxes, shipping, returns, and fees?'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Item1: _TL_('$10/Month Self-Storage'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Item2: _TL_('Free Delivery Over $49'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Item3: _TL_('No Risk 90-Day Returns'),
  Ad_Strength_Suggestion_Tips_Category_Pricing_Item4: _TL_('Prices as low as $29.99'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Title: _TL_('Promotion and discount'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Subtitle: _TL_('What type of deals do you offer?'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Item1: _TL_('Save Up to 30% Off All Orders'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Item2: _TL_('Weekend Deals Available Now'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Item3: _TL_('Get A $100 Sign-up Bonus'),
  Ad_Strength_Suggestion_Tips_Category_Promotion_Item4: _TL_('Buy One, Get One Free'),
};

export const adStrengthSuggestionPerspectiveStrings = {
  Ad_Strength_Suggestion_Perspective_Headline_Title: _TL_('Recommending optimal headlines combinations'),
  Ad_Strength_Suggestion_Perspective_Headline_Pitching_Point: _TL_('Microsoft Advertising recommends the most optimal headline combinations to highlight your business and create effective ads for potential customers.'),
  Ad_Strength_Suggestion_Perspective_Description_Title: _TL_('Recommending optimal descriptions combinations'),
  Ad_Strength_Suggestion_Perspective_Description_Pitching_Point: _TL_('Microsoft Advertising recommends the most optimal description combinations to highlight your business and create effective ads for potential customers.'),
};

export const defaultPromotionSuggestions = [
  { AssetType: 'Headline', Asset: 'Get More for Less' },
  { AssetType: 'Headline', Asset: 'Try Something New' },
  { AssetType: 'Headline', Asset: 'Fast Shipping Available' },
  { AssetType: 'Headline', Asset: 'Limited Time Offer' },
  { AssetType: 'Headline', Asset: 'Free Shipping Today' },
  { AssetType: 'Description', Asset: 'Discover the best deals on our website! Find what you need at unbeatable prices.' },
  { AssetType: 'Description', Asset: 'Discover endless possibilities with our website!' },
];
